export const en = {
  // Header
  header: {
    home: 'Home',
    nonSurgicalAesthetics: 'Non-Surgical Aesthetics',
    surgicalProcedures: 'Surgical Procedures',
    about: 'About',
    blog: 'Blog',
    contact: 'Contact',
    expertDoctor: 'Expert Doctor',
    aestheticsInTurkey: 'Aesthetics in Turkey',
    paymentMethods: 'Payment Methods',
    kvkk: 'GDPR',
    rhinoplasty: 'Rhinoplasty',
    liposuction: 'Liposuction',
    bbl: 'Brazilian Butt Lift',
    tummyTuck: 'Tummy Tuck',
    breastAugmentation: 'Breast Augmentation',
    breastLift: 'Breast Lift',
    breastReduction: 'Breast Reduction',
    gynecomastia: 'Gynecomastia',
    armLift: 'Arm Lift',
    thighLift: 'Thigh Lift',
    genitalAesthetics: 'Genital Aesthetics',
    postBariatricSurgery: 'Post-Bariatric Surgery',
    medicalAesthetics: 'Medical Aesthetics',
    wrinkleTreatment: 'Wrinkle Treatment',
    skinFiller: 'Skin Filler',
    skinCare: 'Skin Care',
    medicalSkinCare: 'Medical Skin Care',
    aquapeelSkinCare: 'Aquapeel Skin Care',
    dermapenApplication: 'Dermapen Application',
    pumpkinPeel: 'Pumpkin Peel',
    regionalSlimming: 'Regional Slimming',
    g5Massage: 'G5 Massage',
    threadLifting: 'Thread Lifting',
    mesotherapy: 'Mesotherapy',
    facialAesthetics: 'Facial Aesthetics',
    eyebrowLift: 'Eyebrow Lift',
    earCorrection: 'Ear Correction',
    dimpleAesthetics: 'Dimple Aesthetics',
    facialFatInjection: 'Facial Fat Injection',
    faceLift: 'Face Lift',
    foreheadLift: 'Forehead Lift',
    neckLift: 'Neck Lift',
    buccalFatRemoval: 'Buccal Fat Removal',
    moleRemoval: 'Mole Removal',
    chinLiposuction: 'Chin Liposuction',
    bodyAesthetics: 'Body Aesthetics',
    breastAesthetics: 'Breast Aesthetics'
  },
  // Footer
  footer: {
    contact: 'Contact',
    address: 'Address',
    phone: 'Phone',
    email: 'Email',
    workingHours: 'Working Hours',
    weekdays: 'Monday - Friday',
    saturday: 'Saturday',
    allRightsReserved: 'All rights reserved',
    socialMedia: 'Social Media',
    aestheticsInTurkey: 'Aesthetics in Turkey',
    paymentMethods: 'Payment Methods',
  },
  // Homepage
  homepage: {
    hero: {
      title: 'Aesthetics and Beauty',
      subtitle: 'Professional Solutions for Your Beauty',
      description: 'We offer the best service for your aesthetic needs with our expert staff and modern techniques.',
      button: 'Make an Appointment',
      slides: {
        rhinoplasty: {
          title: 'Rhinoplasty',
          description: 'A natural nose that matches your face is not a dream! Breathe better and gain confidence with rhinoplasty. It\'s time to add an elegant touch to your beauty! Feel the difference with modern techniques and expert touch. Smile with satisfaction every time you look in the mirror.',
          infoButton: 'Rhinoplasty Information Page'
        },
        liposuction: {
          title: 'Liposuction',
          description: 'Your dream body is now possible! Say goodbye to excess fat with modern liposuction methods. It\'s time to reshape your form! Regional excesses are becoming history, you are being reborn.',
          infoButton: 'Liposuction Information Page'
        },
        bbl: {
          title: 'Brazilian Butt Lift (BBL)',
          description: 'Fuller, shapelier, and more natural buttocks! Add curves to your body with Brazilian Butt Lift. You\'ll be amazed by your new look! Get natural and permanent results with your own fat.',
          infoButton: 'BBL Information Page'
        }
      }
    },
    services: {
      title: 'Our Services',
      subtitle: 'We offer you the best service with modern techniques and our expert staff',
      cards: {
        rhinoplasty: {
          title: 'Rhinoplasty',
          description: 'Meet our expert doctors for a natural nose that matches your face.',
          button: 'Learn More',
        },
        faceLift: {
          title: 'Face Aesthetics',
          description: 'Facial aesthetic operations for a young and dynamic appearance.',
          button: 'Learn More',
        },
        bodyAesthetics: {
          title: 'Body Aesthetics',
          description: 'Professional solutions to achieve your dream body.',
          button: 'Learn More',
        },
      },
    },
    testimonials: {
      title: 'Patient Reviews',
      subtitle: 'Our patients\' experiences and satisfaction are our most valuable feedback',
      viewAll: 'View All Reviews',
      items: {
        rhinoplasty: {
          name: 'Sarah K.',
          location: 'London',
          comment: 'I am very satisfied with my rhinoplasty operation. Thanks to Dr. Barış Çin\'s professional approach and expertise, I got the nose I dreamed of. I felt safe throughout the entire process.',
          rating: 5
        },
        liposuction: {
          name: 'Michael S.',
          location: 'New York',
          comment: 'The change in my body after the liposuction operation is incredible. Thank you to Dr. Barış Çin and his team. I am now more confident in myself.',
          rating: 5
        },
        bbl: {
          name: 'Emma A.',
          location: 'Paris',
          comment: 'I am very happy after my BBL operation. Thanks to Dr. Barış Çin\'s experience and meticulous work, I achieved amazing results. I definitely recommend it.',
          rating: 5
        }
      }
    },
    satisfactionVideos: {
      title: 'Patient Satisfaction Videos',
      subtitle: 'Watch our patients\' experiences and satisfaction in video format',
      viewAll: 'View All Videos',
      items: {
        rhinoplasty: {
          title: 'Rhinoplasty Experience',
          description: 'Patient experience and satisfaction after rhinoplasty operation',
          duration: '3:45'
        },
        liposuction: {
          title: 'Liposuction Experience',
          description: 'Patient experience and satisfaction after liposuction operation',
          duration: '4:20'
        },
        bbl: {
          title: 'BBL Experience',
          description: 'Patient experience and satisfaction after Brazilian Butt Lift operation',
          duration: '3:55'
        }
      }
    },
    about: {
      title: 'About Us',
      readMore: 'Read More',
    },
    contact: {
      title: 'Contact',
      subtitle: 'Contact us for your aesthetic needs',
      name: 'Your Name',
      phone: 'Your Phone',
      message: 'Your Message',
      send: 'Send Message',
      address: 'Address',
      addressValue: 'Kosuyolu District Mehmet Akfan Street No:19-21 Kadikoy Istanbul Turkey',
      email: 'Email',
      emailValue: 'drbariscin86@gmail.com',
      phoneValue: '+90 555 123 4567',
      workingHours: 'Working Hours',
      workingHoursValue: 'Monday - Friday: 09:00 - 18:00',
      socialMedia: 'Social Media',
      socialMediaDescription: 'Follow us on social media for the latest updates and information',
      location: 'Location',
      locationDescription: 'Our clinic is located in the heart of Kadikoy, easily accessible by public transportation',
      appointment: 'Appointment',
      appointmentDescription: 'Contact us immediately to make an appointment at your most convenient time and for detailed information'
    },
    credentials: {
      title: 'Our Certifications',
      subtitle: 'Our Ministry of Health authorization and international health tourism certificates',
      healthTurkiyeTitle: 'Health Türkiye',
      healthTurkiyeDescription: 'Republic of Türkiye Ministry of Health – Health Tourism Authorization',
      certificateTitle: 'Authorization Certificate',
      certificateDescription: 'View our official authorization certificate as PDF',
      viewDocument: 'View Document',
      viewImage: 'Enlarge'
    },
    doctorIntro: {
      title: "EXPERT DOCTOR",
      name: "Op. Dr. Barış Çin",
      description: "Op. Dr. Barış Çin is a Plastic Surgeon who works in his private clinic in Kadıköy and various top-tier hospitals such as Academic and Acıbadem Hospitals. Together with a team striving for excellence, we are at your service 24/7 to provide you with the highest level of aesthetic treatments at affordable prices. Don't postpone your dreams, be happy and beautiful!",
      features: {
        experience: "Thousands of successful operations with 15+ years of experience",
        technology: "Modern techniques and latest technological equipment",
        approach: "Personalized treatment plans and approaches"
      },
      button: "Make an Appointment"
    },
  },
  // WhatsApp messages
  whatsapp: {
    appointmentMessage: "Hello, I would like to make an appointment."
  },
  about: {
    aestheticsInTurkey: {
      title: "Aesthetics in Turkey",
      content: {
        intro: "Aesthetic Surgery in Turkey and Frequently Asked Questions About Traveling to Turkey",
        advantages: {
          title: "Is Aesthetic Surgery Performed in Turkey?",
          items: [
            "Turkey has become one of the top countries preferred by thousands of foreign tourists coming from abroad in recent years for aesthetic surgeries (liposuction, tummy tuck, breast augmentation/lift, etc.).",
            "The reason why thousands of foreign tourists prefer Turkey for aesthetic surgery is that Turkey hosts hospitals with JCI (Joint Commission International) accreditation and highly successful surgeons with advanced technology in the field of health, in addition to its cultural values in history and art.",
            "If you want to have the aesthetic surgery you need to achieve your desired body in Istanbul, you should meet Dr. Barış Çin and his team, who serves in his clinic in Istanbul and is a surgeon with European Board Certification.",
            "With 10 years of experience, the aesthetic operations you need have been successfully performed for years by Dr. Barış Çin and his team."
          ]
        },
        statistics: {
          title: "How many foreign tourists choose to have aesthetic surgery in Turkey per year?",
          description: "In the first half of 2022 alone, 600,000 foreign tourists came to Turkey, which is quite successful and popular in health tourism, to have aesthetic and other surgeries."
        },
        procedures: {
          title: "What are the 10 most popular aesthetic surgeries performed in Turkey?",
          items: [
            "Rhinoplasty",
            "Breast Reduction",
            "Liposuction",
            "Breast Augmentation",
            "Eyelid Surgery",
            "Tummy Tuck",
            "Ear Pinning",
            "Buccal Fat Removal",
            "BBL",
            "Eye Corner Surgery"
          ],
          additional: "However, aesthetic surgeries performed in Turkey are not limited to these. In addition, face lift, arm lift, thigh lift, back lift, vaginal aesthetics, eyebrow lift, temple lift, and fox eye surgeries are also successfully performed."
        },
        istanbul: {
          title: "Why should you have aesthetic surgery in Istanbul?",
          description: "There are multiple reasons to prefer Istanbul for aesthetic surgery.",
          history: "Istanbul is Turkey's most developed and largest city. Istanbul is the only city in the world located on both the Asian and European continents. Istanbul's history dates back to 8500 BC, and it gained great importance during the Roman Empire period (330-396 AD). The massive Agios Sofia church, built in 576 AD, still stands with all its magnificence today.",
          advantages: "While visiting the city of Istanbul, which is rich in history and culture, you can also access aesthetic surgeries at reasonable prices in hospitals with JCI (Joint Commission International) accreditation with advanced technology, performed by highly successful surgeons."
        }
      }
    },
    paymentMethods: {
      title: "Payment Methods",
      content: {
        intro: "The payment types for procedures performed in our clinic are as follows. As in all healthcare institutions, the fees for surgery and medical procedures are collected before the procedure begins. (except for some emergency cases)",
        deposit: {
          title: "Deposit and Cancellation Conditions",
          description: "If the operations of our patients who will undergo surgery are to be performed in a private hospital, a deposit of approximately 300 euros is required to make an appointment with the hospital. This deposit is refunded if cancelled up to 1 week before the surgery. However, if the surgery is cancelled at the last minute for arbitrary reasons, hospitals charge a penalty fee as they cannot create new appointments. The deposit is refunded after deducting this fee. If the operation is cancelled due to reasons such as being covid+, infection, or unfavorable anesthesia test results, there is no penalty fee. However, the fees for blood tests and other procedures performed at the hospital are deducted before the refund. If the operation or procedure is to be performed in the office, no deposit is required. However, if there will be airport transfer, a deposit may be taken for its payment."
        },
        methods: {
          title: "Payment Methods",
          items: [
            {
              title: "Cash",
              description: "We accept payments in Turkish Lira, Dollar, and Euro at our clinic. The advantage of this method is that there are no commission and currency conversion fees."
            },
            {
              title: "Physical POS",
              description: "We have a physical POS device from İş Bankası in our clinic. However, free installment is not available. However, patients can make installments with interest through their own banks after withdrawing from their credit card or bank card. In transactions made through POS, banks charge an average of 2% from the cardholder and 2% from the merchant. Additionally, they charge 6% under DCC (direct currency exchange) for currency conversion. Therefore, the transaction fee increases by about 8-10%."
            },
            {
              title: "Virtual POS",
              description: "We can send a payment link through İş Bankası's virtual POS system for our patients who cannot reach our clinic, especially those coming from abroad, to pay their deposits."
            },
            {
              title: "Western Union",
              description: "Payments can be sent to our clinic via Western Union in the name of \"Barış Çin\" at İş Bankası Ataşehir Branch, Istanbul, Turkey. Banks charge a transaction fee between 4.4-20% depending on the amount to be sent."
            }
          ]
        },
        bankTransfer: {
          title: "Bank Transfer – EFT",
          description: "Direct transfers and EFT can be made to the account number below for payment. Banks charge transfer fees, currency conversion fees if applicable, and commission.",
          accounts: {
            try: {
              title: "Turkish Lira",
              bank: "İş Bankası Ataşehir Branch (1226)",
              iban: "TR23 0006 4000 0011 2260 5541 37"
            },
            eur: {
              title: "Euro Account",
              bank: "İş Bankası Ataşehir Branch",
              iban: "TR22 0006 4000 0021 2260 4930 40"
            },
            usd: {
              title: "Dollar Account",
              bank: "İş Bankası Ataşehir Branch",
              iban: "TR67 0006 4000 0021 2260 5016 39"
            }
          }
        },
        swift: {
          title: "SWIFT",
          description: "For our patients who want to send money from abroad to the account above, İş Bankası's SWIFT code is ISBKTRIS. For transfers from the USA, CHIPS UID: 003546 (used instead of Routing Code, ABA Number). Additionally, for the transfer to reach the recipient more easily, the recipient's name, surname (Barış Çin) and address (Koşuyolu Mahallesi Mehmet Akfan Sokak No:19-21 Kadıköy İstanbul Turkey) should be written completely, and if known, the recipient's 26-digit IBAN starting with TR (International Bank Account Number: TR670006400000212260501639 (dollar))",
          note: "Especially in bank transfers and SWIFT transactions from abroad, it may take up to 2-3 weeks for the money to reach Turkey, and sometimes transfers from European Union countries may be held for verification due to \"fraud\" suspicion. Additionally, the receiving bank may charge a fee for the money to be credited to the account. Therefore, we recommend prioritizing Cash and POS devices for international transactions, and if EFT and SWIFT are to be made, they should be done at least 1 month in advance. If the full amount requested before the operation or procedure is not received, the procedure will not be performed. Patients who will make EFT and SWIFT payments must make transfers between accounts in the same currency, otherwise the sent money will not reach the recipient's account. (From Turkish Lira to Turkish Lira account, from dollar account to dollar account, from euro account to euro account, etc.)"
        }
      }
    }
  },
  doctorInfo: {
    title: "Doctor Information",
    name: "Doctor Name",
    specialty: "Specialty",
    specialtyValue: "Aesthetic, Plastic and Reconstructive Surgery",
    email: "E-mail",
    phone: "Phone",
    socialMedia: "Social Media",
    educationExperience: "Education & Experience",
    education: "Education",
    educationValue: "Marmara University, Istanbul, Turkey",
    experience: "Experience",
    experienceValue: "15+ years of experience",
    expertise: "Expertise",
    expertiseValue: "Aesthetic, Plastic and Reconstructive Surgery Specialist",
    biography: "Biography",
    biographyText1: "Op. Dr. Barış Çin is an experienced Plastic, Reconstructive and Aesthetic Surgery specialist who practices at his private clinic in Kadıköy and at leading healthcare institutions such as Academic and Acıbadem Hospitals.",
    biographyText2: "As a nationally and internationally recognized physician, he aims to provide aesthetic solutions at high quality standards at affordable costs with his expert team. With his patient satisfaction-oriented approach, he provides 24/7 support to his clients.",
    europeanBoard: "European Board Certificate: April 6, 2019, Brussels / Belgium",
    turkishBoard: "Turkish Board Certificate: September 28, 2018, Ankara / Turkey",
    professionalSkills: "Professional Skills",
    skillsDescription: "Op. Dr. Barış Çin has expertise in a wide range of aesthetic and reconstructive surgery. Below you can see some of his prominent skills:",
    facialAesthetics: "Facial Aesthetics",
    bodyAesthetics: "Body Aesthetics",
    rhinoplasty: "Rhinoplasty",
    breastAesthetics: "Breast Aesthetics",
    careerJourney: "Career Journey",
    careerText1: "After completing his primary education in Ankara, Dr. Barış Çin won Ankara Gazi Anatolian High School and received one year of English preparatory education. Then, after moving to Riyadh/Saudi Arabia with his family, he continued his education at Riyadh American International School and successfully completed his high school education.",
    careerText2: "After returning to Turkey, he graduated by completing his final year of high school at Ankara Atatürk Anatolian High School. He started his medical education at Marmara University Faculty of Medicine and successfully completed this institution, earning the title of medical doctor.",
    careerText3: "Through the Medical Specialization Exam, he was placed in the Department of Plastic, Reconstructive and Aesthetic Surgery at Istanbul Haydarpaşa Numune Training and Research Hospital, where he continued his specialization process. During this period, he gained many scientific studies and case experience.",
    careerText4: "His academic achievements and disciplined approach during his specialization laid the groundwork for his subsequent international experiences and clinical practice. Throughout his post-graduation career, he has gained a respected position both nationally and internationally.",
    educationAcademic: "Education & Academic Experience",
    educationText1: "During his specialization, he was a clinical observer in jaw surgery at the Department of Jaw Surgery at GB Hamburg University in Hamburg/Germany, and in craniofacial developmental disorders at the Department of Craniofacial Surgery at Oxford University in Oxford/England. His thesis was published as an article in Aesthetic Plastic Surgery, one of the world's most prestigious scientific publications in the field of aesthetic surgery (Cin B. 2020 Jun;44(3):1087-1088). In addition to his thesis, his articles have been published in many national and international academic journals.",
    educationText2: "On September 28, 2018, he earned the Qualification Certificate by showing success in written and oral exams organized by the Turkish Plastic Reconstructive and Aesthetic Surgery Association. On April 6, 2019, he successfully completed the European Qualification Exams in Brussels and was accredited by the European Board of Plastic, Reconstructive and Aesthetic Surgery. Between 2021-2022, he served as an Assistant Professor at the Department of Plastic Surgery, Faculty of Medicine, Okan University. Since 2021, he has been accepting patients as a private practitioner at his private practice in Istanbul.",
    appointmentInfo: "Appointment and Information",
    appointmentDescription: "Contact us immediately to make an appointment at your most convenient time and for detailed information"
  },
  skinFiller: {
    title: "Skin Filler",
    description: "Skin filler is an effective aesthetic application used to rejuvenate your facial features and restore volume loss.",
    hero: {
      title: "Skin Filler",
      description: "Aesthetic skin filler is a treatment applied to reduce signs of aging and make the skin look younger, smoother, and fuller.",
      appointmentButton: "Make an Appointment",
      learnMoreButton: "Learn More"
    },
    content: {
      whatIs: {
        title: "What is Skin Filler?",
        description: "Aesthetic skin filler is a treatment applied to reduce signs of aging and make the skin look younger, smoother, and fuller. Over time, the skin loses elasticity, collagen production decreases, and facial features become more pronounced. Wrinkles, fine lines, and volume loss occur in this case. Skin fillers can be used to address these issues.",
        materials: "Polycaprolactone, hyaluronic acid, calcium hydroxylapatite, or other natural or synthetic materials make up the skin filler. Hyaluronic acid, which is naturally found in the skin, is a substance with high moisture retention capacity. These materials are injected under the skin to restore wrinkles, fine lines, and volume loss."
      },
      why: {
        title: "Why is Skin Filler Done?",
        reasons: [
          "To reduce wrinkles and fine lines",
          "To enhance facial features",
          "To restore lost volume",
          "To plump lips",
          "To treat acne scars and other skin blemishes",
          "As a non-surgical aesthetic option",
          "To achieve natural and aesthetic appearance",
          "To improve self-confidence and quality of life"
        ]
      },
      how: {
        title: "How is Skin Filler Applied?",
        description: "The skin filler procedure is typically completed in a short time and is minimally invasive. The filler is injected under the skin using a fine needle or cannula during the procedure. Before the treatment begins, the specialist doctor carefully applies the injection areas.",
        process: "On the day of the procedure, the areas to be injected are first cleaned and sterilized. Then, a process is carried out to determine and mark the places where the filler material will be injected. Most often, a local anesthetic cream or injection is applied to alleviate pain during the injection."
      },
      who: {
        title: "Who is Skin Filler Suitable For?",
        description: "Skin filler is generally suitable for people dealing with wrinkles and fine lines. As age progresses, the skin becomes less elastic and wrinkles become more pronounced. In this case, the skin filler procedure can be used to achieve a younger appearance by filling wrinkles and gaps.",
        volumeLoss: "People experiencing facial volume loss can also use skin fillers. When facial features lose their definition, areas such as lips, cheeks, and jaw can be reshaped with fillers. This procedure makes the face look younger and fuller."
      },
      benefits: {
        title: "Benefits of Skin Filler",
        description: "Skin filler provides quick and effective results. The procedure usually takes thirty to one hour, and results begin to be seen immediately. This is a great advantage, especially for people with social life or a busy work schedule.",
        natural: "Filler materials are used to support the skin's natural structure. When natural substances such as hyaluronic acid are used, the skin can retain more moisture and increase collagen production. This improves the overall condition of the skin and makes it look younger."
      }
    },
    quickInfo: {
      title: "Quick Information",
      duration: "30-60 minutes",
      anesthesia: "Local anesthesia",
      recovery: "1-2 days"
    },
    faq: {
      title: "Frequently Asked Questions",
      questions: [
        {
          question: "Is skin filler permanent?",
          answer: "Hyaluronic acid fillers are effective for 6-12 months. Some filler materials can provide longer-lasting results."
        },
        {
          question: "Is skin filler painful?",
          answer: "Local anesthesia is applied during the procedure, so pain is minimal."
        }
      ]
    },
    pricing: {
      title: "Pricing",
      hyaluronic: {
        title: "Hyaluronic Acid Filler",
        price: "€150 - €300",
        note: "Varies according to the brand and amount of filler material used"
      },
      calcium: {
        title: "Calcium Hydroxylapatite",
        price: "€200 - €400",
        note: "For longer-lasting results"
      },
      lips: {
        title: "Lip Filler",
        price: "€150 - €250",
        note: "Varies according to lip volume and shape"
      },
      jawline: {
        title: "Jawline Filler",
        price: "€250 - €400",
        note: "For applications requiring more filler material"
      },
      note: "* Prices may vary depending on the area of application, materials used, and scope of the procedure. Pre and post-procedure care costs should be considered in addition to skin filler prices. Total cost may vary due to recommended post-procedure care products or additional treatments."
    }
  },
  contact: {
    title: 'Contact',
    contactInfo: {
      title: 'Contact Information',
      address: {
        title: 'Address',
        content: 'Kosuyolu District Mehmet Akfan Street No:19-21 Kadikoy Istanbul Turkey'
      },
      phone: {
        title: 'Phone',
        content: '+90 555 123 4567'
      },
      email: {
        title: 'Email',
        content: 'drbariscin86@gmail.com'
      }
    },
    workingHours: {
      title: 'Working Hours',
      days: [
        { name: 'Monday - Friday', hours: '09:00 - 18:00' },
        { name: 'Saturday', hours: '09:00 - 14:00' },
        { name: 'Sunday', hours: 'Closed' }
      ]
    }
  },
}; 